export const audiobooks = [
  {
    author: 'Tate James',
    title: 'Hate',
    series: {
      name: 'Madison Kate',
      number: 1,
      seriesComplete: true,
    },
    narrators: ['Megan Coffey'],
    audioLength: '10h 25m',
    publisher: 'Findaway Voices',
    audioFormat: 'MP3',
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=400&h=600&fit=crop',
    audioSampleUrl: 'https://audible.sample.url/hate-sample.mp3',
    relationshipTypes: ['Why Choose'],
    burnLevel: 'Medium Burn',
    endingType: 'Cliffhanger',
    povStyle: 'Multi First Person',
    spiceLevel: 4,
    darknessLevel: 'Medium',
    tropes: ['Enemies to Lovers', 'College Romance', 'Revenge'],
    contentWarnings: ['Violence', 'Stalking', 'Sexual Content'],
    genre: 'Romance',
    subgenres: ['Dark Romance', 'New Adult'],
  },
  {
    author: 'Caroline Peckham & Susanne Valenti',
    title: 'The Awakening',
    series: {
      name: 'Zodiac Academy',
      number: 1,
      seriesComplete: false,
    },
    narrators: ['Lauren Raye'],
    audioLength: '13h 10m',
    publisher: 'Audible',
    audioFormat: 'MP3',
    coverImage:
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=400&h=600&fit=crop',
    audioSampleUrl: 'https://audible.sample.url/awakening-sample.mp3',
    relationshipTypes: ['Why Choose'],
    burnLevel: 'Slow Burn',
    endingType: 'Cliffhanger',
    povStyle: 'Dual First Person',
    spiceLevel: 3,
    darknessLevel: 'Dark',
    tropes: ['Academy', 'Enemies to Lovers', 'Hidden Identity'],
    contentWarnings: ['Bullying', 'Violence', 'Sexual Content'],
    genre: 'Fantasy',
    subgenres: ['Dark Fantasy', 'Romance', 'New Adult'],
  },
  {
    author: 'Ruby Dixon',
    title: 'Ice Planet Barbarians',
    series: {
      name: 'Ice Planet Barbarians',
      number: 1,
      seriesComplete: false,
    },
    narrators: ['Janet Metzger'],
    audioLength: '14h 52m',
    publisher: 'Audible',
    audioFormat: 'MP3',
    coverImage:
      'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?w=400&h=600&fit=crop',
    audioSampleUrl: 'https://audible.sample.url/iceplanet-sample.mp3',
    relationshipTypes: ['MF'],
    burnLevel: 'Fast Burn',
    endingType: 'HEA',
    povStyle: 'Dual First Person',
    spiceLevel: 5,
    darknessLevel: 'Medium',
    tropes: ['Alien Romance', 'Forced Proximity', 'Fated Mates'],
    contentWarnings: ['Abduction', 'Sexual Content'],
    genre: 'Science Fiction',
    subgenres: ['Sci-Fi Romance', 'Alien Romance'],
  },
  {
    author: 'Ali Hazelwood',
    title: 'The Love Hypothesis',
    series: {
      name: '',
      number: 1,
      seriesComplete: true,
    },
    narrators: ['Julia Whelan'],
    audioLength: '7h 14m',
    publisher: 'Audible',
    audioFormat: 'MP3',
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&h=600&fit=crop',
    audioSampleUrl: 'https://audible.sample.url/lovehypothesis-sample.mp3',
    relationshipTypes: ['MF'],
    burnLevel: 'Medium Burn',
    endingType: 'HEA',
    povStyle: 'Single First Person',
    spiceLevel: 2,
    darknessLevel: 'Light',
    tropes: ['Fake Dating', 'Grumpy/Sunshine', 'STEM Heroine'],
    contentWarnings: ['Sexual Content'],
    genre: 'Romance',
    subgenres: ['Contemporary', 'RomCom'],
  },
  {
    author: 'Katee Robert',
    title: 'Neon Gods',
    series: {
      name: 'Dark Olympus',
      number: 1,
      seriesComplete: false,
    },
    narrators: ['Alex Mooreland', 'Jason Clarke'],
    audioLength: '9h 38m',
    publisher: 'Audible',
    audioFormat: 'MP3',
    coverImage:
      'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=400&h=600&fit=crop',
    audioSampleUrl: 'https://audible.sample.url/neongods-sample.mp3',
    relationshipTypes: ['MF'],
    burnLevel: 'Fast Burn',
    endingType: 'HEA',
    povStyle: 'Dual First Person',
    spiceLevel: 5,
    darknessLevel: 'Medium',
    tropes: ['Mythology Retelling', 'Forbidden Love', 'Age Gap'],
    contentWarnings: ['Sexual Content', 'Violence'],
    genre: 'Romance',
    subgenres: ['Dark Romance', 'Contemporary'],
  },
  {
    author: 'Jennifer L. Armentrout',
    title: 'From Blood and Ash',
    series: {
      name: 'Blood and Ash',
      number: 1,
      seriesComplete: false,
    },
    narrators: ['Stina Nielsen', 'Tim Gerard Reynolds'],
    audioLength: '17h 6m',
    publisher: 'Audible',
    audioFormat: 'MP3',
    coverImage:
      'https://images.unsplash.com/photo-1589998059171-988d887df646?w=400&h=600&fit=crop',
    audioSampleUrl: 'https://audible.sample.url/bloodandash-sample.mp3',
    relationshipTypes: ['MF'],
    burnLevel: 'Slow Burn',
    endingType: 'Cliffhanger',
    povStyle: 'Dual First Person',
    spiceLevel: 4,
    darknessLevel: 'Dark',
    tropes: ['Forbidden Love', 'Chosen One', 'Hidden Identity'],
    contentWarnings: ['Violence', 'Sexual Content', 'Death'],
    genre: 'Fantasy',
    subgenres: ['Romantasy', 'Dark Fantasy'],
  },
  {
    author: 'Penelope Douglas',
    title: 'Credence',
    series: {
      name: '',
      number: 1,
      seriesComplete: true,
    },
    narrators: ['Elena Wolfe', 'Jacob Morgan', 'Sebastian York'],
    audioLength: '13h 44m',
    publisher: 'Audible',
    audioFormat: 'MP3',
    coverImage:
      'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=400&h=600&fit=crop',
    audioSampleUrl: 'https://audible.sample.url/credence-sample.mp3',
    relationshipTypes: ['Why Choose'],
    burnLevel: 'Medium Burn',
    endingType: 'HEA',
    povStyle: 'Multi First Person',
    spiceLevel: 5,
    darknessLevel: 'Dark',
    tropes: ['Taboo', 'Forced Proximity', 'Age Gap'],
    contentWarnings: ['Sexual Content', 'Taboo Relationships', 'Violence'],
    genre: 'Romance',
    subgenres: ['Dark Romance', 'New Adult'],
  },
  {
    author: 'Scarlett St. Clair',
    title: 'A Touch of Darkness',
    series: {
      name: 'Hades X Persephone',
      number: 1,
      seriesComplete: true,
    },
    narrators: ['Meg Sylvan', 'Gary Furlong', 'Ava Lucas', 'Connor Crais'],
    audioLength: '10h 15m',
    publisher: 'Audible',
    audioFormat: 'MP3',
    coverImage:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=600&fit=crop',
    audioSampleUrl: 'https://audible.sample.url/touchofdarkness-sample.mp3',
    relationshipTypes: ['MF'],
    burnLevel: 'Medium Burn',
    endingType: 'Cliffhanger',
    povStyle: 'Multi First Person',
    spiceLevel: 4,
    darknessLevel: 'Medium',
    tropes: ['Mythology Retelling', 'Forced Proximity', 'Power Imbalance'],
    contentWarnings: ['Sexual Content', 'Violence', 'Death'],
    genre: 'Fantasy',
    subgenres: ['Romantasy', 'Dark Fantasy', 'Romance'],
  },
]
